/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type PriceLookupKeyEnum =
  (typeof PriceLookupKeyEnum)[keyof typeof PriceLookupKeyEnum];

export const PriceLookupKeyEnum = {
  BasicStandardPrice: "BasicStandardPrice",
  PremiumStandardPrice: "PremiumStandardPrice",
  AnalyseStandardPrice: "AnalyseStandardPrice",
} as const;
